import React from 'react';

export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 9.8V1.4C14 1.0287 13.8525 0.672601 13.5899 0.41005C13.3274 0.1475 12.9713 0 12.6 0H4.2C3.8287 0 3.4726 0.1475 3.21005 0.41005C2.9475 0.672601 2.8 1.0287 2.8 1.4V9.8C2.8 10.1713 2.9475 10.5274 3.21005 10.7899C3.4726 11.0525 3.8287 11.2 4.2 11.2H12.6C12.9713 11.2 13.3274 11.0525 13.5899 10.7899C13.8525 10.5274 14 10.1713 14 9.8ZM6.3 7L7.721 8.897L9.8 6.3L12.6 9.8H4.2M0 2.8V12.6C0 12.9713 0.1475 13.3274 0.41005 13.5899C0.672601 13.8525 1.0287 14 1.4 14H11.2V12.6H1.4V2.8" fill="currentColor" />
  </svg>
);
